// Module
var code = "<svg width=\"24\" height=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-opacity=\".3\" stroke=\"currentColor\" d=\"M5.5 5.5h10v9h-10z\"/><path d=\"M12.556 20.1a.5.5 0 0 0 .916.162l2.337-3.809 4.278-.76a.5.5 0 0 0 .163-.926l-9-5.2a.5.5 0 0 0-.74.533l2.046 10z\" stroke=\"#3B3B3B\" stroke-linejoin=\"round\"/></svg>";
// Exports
module.exports = code;